export default __webpack_public_path__ + "static/media/Envelope.b278dc3c.webm";